export default {
  GET_PUBLISHER_REQUESTED: 'GET_PUBLISHER_REQUESTED',
  GET_PUBLISHER_SUCCEEDED: 'GET_PUBLISHER_SUCCEEDED',
  GET_PUBLISHER_FAILED: 'GET_PUBLISHER_FAILED',

  SHOW_PUBLISHER_VIEW: 'SHOW_PUBLISHER_VIEW',
}
